// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "index" + "." + "1264a98cc128e5016570" + ".js";
};